import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import TexasGroupingTable from "./view/TexasGroupingTable";

interface Props {}

export const TexasGrouping = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_officeconfiguration_texasgrouping_view;
    const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <> {userPermissions.includes(viewPermission) && <TexasGroupingTable />} </>
  );
};

export default TexasGrouping;